// extracted by mini-css-extract-plugin
export default {"aboutBannerContainer":"AboutBanner_aboutBannerContainer__0f8RN","content":"AboutBanner_content__4UwzX","image":"AboutBanner_image__bLp-Q"};